import {
  GET_ADD_APP_PERMISSION,
  GET_APPLICATION_LISTING,
  GET_APP_AREA_LISTING,
  GET_CHECK_APP_PERMISSION,
  GET_CATEGORY_LISTING,
  GET_ACTIVE_CATEGORY,
  GET_CHECK_CATEGORY,
  GET_ADD_CATEGORY,
  GET_APP_PERMISSION_LISTING,
  GET_APP_PERMISSION_BY_ID,
  GET_DELETE_APP_PERMISSION,
  GET_APP_AREA_CHECK,
  GET_ADD_APP_AREA,
  GET_APP_AREA_BY_ID,
  GET_APPLICATION_CHECK,
  GET_ADD_APPLICATION,
  GET_DELETE_CATEGORY,
  GET_CATEGORY_BY_ID,
  GET_DELETE_APP_AREA,
  GET_ACTIVE_APPLICATION,
  GET_ACTIVE_APP_AREA,
  GET_APPLICATION_BY_ID,
  GET_DELETE_APPLICATION,
  GET_CREATE_USER,
  GET_USER_GRID_DATA,
  GET_USER,
  UPDATE_CREATE_USER,
  GET_USER_UPN_DATA,
  GET_SECURITY_PERMISSION_LISTING,
  GET_SECURITY_ROLE_LISTING,
  GET_ACTIVE_ROLES,
  GET_ADD_SECURITY_ROLE,
  GET_SECURITY_ROLE_BY_ID,
  GET_DELETE_SECURITY_ROLE,
  GET_USER_DIVISIONS,
  GET_USER_COST_CENTER,
  GET_CHECK_USER,
  GET_TIME_ZONE,
  UPLOAD_APPLICATION_ICON
} from './types'
import api from '../../client/utils/clientApiHelper'
import { all, takeEvery, put, call } from 'redux-saga/effects'
import * as UserManageDetailActions from './action';
import { globalLoaderText } from 'redux/CommonDashboard/actions';
import { API_URL, apiMethod, apiType } from 'utils';
import { IPayload } from 'Model/IPayload';

function* checkAppPerDuplication(req: any): any {
  yield put(globalLoaderText("Checking Duplication...."));
  try {
    let permissionName = req.val.permissionName;
    let appId = req.val.applicationID;
    let appAreaId = req.val.appAreaId;
    let id = req.val.id;
    let payloadData : IPayload= {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `permissions/check?permissionName=${permissionName}&appId=${appId}&appAreaId=${appAreaId}&permissionId=${id}`,
      payload : null
    }
    const response = yield call(
      api.callUserPost, API_URL.PostWebApp,payloadData
     
    );
    yield put(UserManageDetailActions.SetCheckAppPermission(response));
    yield put(UserManageDetailActions.setIsCheck((prev: any) => !prev));
    if (response == false) {

      yield put(UserManageDetailActions.setIsCheckAppPer(false));
    } else {
      yield put(UserManageDetailActions.setIsCheckAppPer(true));
      yield put(UserManageDetailActions.SetAddAppPermission(0))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setIsCheckAppPer(true));
    yield put(UserManageDetailActions.SetCheckAppPermission(true));
    yield put(UserManageDetailActions.SetAddAppPermission(0))
    yield put(globalLoaderText(""));
  }
}

function* createApplicationPermission(req: any): any {
  yield put(globalLoaderText("loading...."));
  let response: any = 0;
  try {
    let val = req.order
    let payloadData : IPayload = {
      apiMethod: apiMethod.POST,
      apiType: apiType.Identity,
      endpoint: `permissions`,
      payload: val
    }
    let payloadDataForPut = {
      apiMethod: apiMethod.PUT,
      apiType: apiType.Identity,
      endpoint: `permissions`,
      payload: val
    }
    if (req.order.id == 0) {
      yield put(globalLoaderText("Creating Application Permission...."));
      response = yield call(
        api.callUserPost,
        API_URL.PostWebApp, payloadData
      );
    } else {
      yield put(globalLoaderText("Updating Application Permission...."));
      response = yield call(
        api.callUserPost,
        API_URL.PostWebApp, payloadDataForPut
      );
    }
    if (response) {
      yield put(UserManageDetailActions.SetAddAppPermission(response))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.SetAddAppPermission("error"))
    yield put(globalLoaderText(""));
  }
}

function* getApplicationListingData(): any {
  yield put(globalLoaderText("fetching Datas...."));
  try {

    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setApplicationList(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setApplicationList([]));
  }
}

function* getAppAreaListingData(): any {
  yield put(globalLoaderText("fetching Datas...."));
  try {

    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/appareas`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setAppAreaList(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setAppAreaList([]));
  }
}

function* getCategoryListingData(): any {
  yield put(globalLoaderText("fetching Datas...."));
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/categories`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setCategoryList(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setCategoryList([]));
  }
}

function* getActiveCategoryData(): any {
  yield put(globalLoaderText("fetching Datas...."));
  try {

    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/categories/active`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    const defaultOption = {
      text: "Select Category",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(UserManageDetailActions.SetActiveCategory(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.SetActiveCategory([]));
  }
}

function* getActiveApplicationData(): any {
  yield put(globalLoaderText("fetching Datas...."));
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/active`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    const defaultOption = {
      text: "Select Application",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(UserManageDetailActions.SetActiveApplication(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.SetActiveApplication([]));
  }
}

function* getActiveAppAreaData(val: any): any {
  yield put(globalLoaderText("fetching Datas...."));
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/appareas/active?applicationId=${val.val}`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData);
    const defaultOption = {
      text: "Select App Area",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(UserManageDetailActions.SetActiveAppArea(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.SetActiveAppArea([]));
  }
}

function* checkCategoryDuplication(req: any): any {
  yield put(globalLoaderText("Checking Duplication...."));
  try {
    let categoryName = req.val.categoryName;
    let categoryId = req.val.id
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/categories/check?categoryId=${categoryId}&categoryName=${categoryName}`,
      payload : null
    }
    const response = yield call(
      api.callUserPost, API_URL.PostWebApp, payloadData      
    );
    yield put(UserManageDetailActions.setCheckCategory(response));
    yield put(UserManageDetailActions.setIsCheck((prev: any) => !prev));
    if (response == false) {

      yield put(UserManageDetailActions.setIsCategoryCheck(false));
    } else {
      yield put(UserManageDetailActions.setIsCategoryCheck(true));
      yield put(UserManageDetailActions.SetAddCategory(0))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setIsCategoryCheck(true));
    yield put(UserManageDetailActions.setCheckCategory(true));
    yield put(UserManageDetailActions.SetAddCategory(0))
    yield put(globalLoaderText(""));
  }
}

function* createCategory(req: any): any {
  yield put(globalLoaderText("loading...."));
  try {
    let response: any = 0;
    let val = req.order;
    let payloadData : IPayload = {
      apiMethod: apiMethod.POST,
      apiType: apiType.Identity,
      endpoint: req?.type == GET_ADD_CATEGORY ? `applications/categories` : `applications/appareas`,
      payload: val
    }
    if (req.order.id == 0) {
      yield put(globalLoaderText(req?.type == GET_ADD_CATEGORY ? "Creating Category...." : "Creating App Area...."));
      response = yield call(
        api.callUserPost, API_URL.PostWebApp, payloadData
      );
    } else {

      payloadData.apiMethod = apiMethod.PUT

      yield put(globalLoaderText(req?.type == GET_ADD_CATEGORY ? "Updating Category...." : "Updating App Area...."));
      response = yield call(
        api.callUserPost, API_URL.PostWebApp, payloadData
      );
    }
    if (response) {
      if(req?.type == GET_ADD_CATEGORY){
      yield put(UserManageDetailActions.SetAddCategory(response))
      }else{
        yield put(UserManageDetailActions.SetAddAppArea(response))
      }
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    if(req?.type == GET_ADD_CATEGORY){
    yield put(UserManageDetailActions.SetAddCategory("error"))
    }else{
      yield put(UserManageDetailActions.SetAddAppArea("error"))
    }
    yield put(globalLoaderText(""));
  }
}

function* getAppPermissionListData(req: any): any {
  yield put(globalLoaderText("fetching App Permission Data...."));
  let appId = req.val.appId
  let appAreaId = req.val.appAreaId
  let payloadData : IPayload = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Identity,
    endpoint: `permissions?appId=${appId}&appAreaId=${appAreaId}`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData);
    yield put(UserManageDetailActions.setAppPermissionListing(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setAppPermissionListing([]));
  }
}

function* getAppPermissionById(req: any): any {
  yield put(globalLoaderText("fetching App Permission Data...."));
  let appPermissionId = req.val
  let payloadData : IPayload = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Identity,
    endpoint: `permissions/${appPermissionId}`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setAppPermissionById(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setAppPermissionById([]));
  }
}

function* getSecurityRoleById(req: any): any {
  yield put(globalLoaderText("fetching Security Role Data...."));
  let securityRoleId = req.val
  let payloadData : IPayload = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Identity,
    endpoint: `users/userroles/${securityRoleId}`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData);
    yield put(UserManageDetailActions.setSecurityRoleById(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setSecurityRoleById([]));
  }
}

function* deleteAppPermission(req: any): any {
  yield put(globalLoaderText("Deleting App Permission...."));
  let appPermissionId = req.val
  let payloadData : IPayload = {
    apiMethod: apiMethod.PUT,
    apiType: apiType.Identity,
    endpoint: `permissions/${appPermissionId}`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setDeleteAppPermission(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setDeleteAppPermission(false));
    yield put(globalLoaderText(""));
  }
}

function* deleteSecurityRole(req: any): any {
  yield put(globalLoaderText("Deleting Security Role...."));
  let UserRoleId = req.val
  let payloadData : IPayload ={
    apiMethod: apiMethod.PUT,
    apiType: apiType.Identity,
    endpoint: `users/userroles/${UserRoleId}`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost,API_URL.PostWebApp,payloadData );
    yield put(UserManageDetailActions.setDeleteSecurityRole(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setDeleteSecurityRole(false));
    yield put(globalLoaderText(""));
  }
}

function* checkAppAreaDuplication(req: any): any {
  yield put(globalLoaderText("Checking Duplication...."));
  try {
    let appAreaName = req.val.applicationAreaName;
    let appId = req.val.applicationId;
    let appAreaId = req.val.id;
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/appareas/check?applicationId=${appId}&appAreaId=${appAreaId}&appAreaName=${appAreaName}`,
      payload : null
    }
    const response = yield call(
      api.callUserPost, API_URL.PostWebApp, payloadData      
    );
    yield put(UserManageDetailActions.setCheckAppArea(response));
    yield put(UserManageDetailActions.setIsCheck((prev: any) => !prev));
    if (response == false) {

      yield put(UserManageDetailActions.setIsAppAreaCheck(false));
    } else {
      yield put(UserManageDetailActions.setIsAppAreaCheck(true));
      yield put(UserManageDetailActions.SetAddAppArea(0))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setIsAppAreaCheck(true));
    yield put(UserManageDetailActions.setCheckAppArea(true));
    yield put(UserManageDetailActions.SetAddAppArea(0))
    yield put(globalLoaderText(""));
  }
}

function* getAppAreaById(req: any): any {
  yield put(globalLoaderText("fetching App Area Data...."));
  let appPermissionId = req.val
  try {

    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/appareas/${appPermissionId}`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setAppAreaById(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setAppAreaById([]));
  }
}

function* checkApplicationDuplication(req: any): any {
  yield put(globalLoaderText("Checking Duplication...."));
  try {
    let applicationName = req.val.applicationName;
    let appCategoryId = req.val.categoryId;
    let id = req.val.id

    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/check?applicationId=${id}&applicationName=${applicationName}&appCategoryId=${appCategoryId}`,
      payload : null
    }
    const response = yield call(
      api.callUserPost, API_URL.PostWebApp, payloadData      
    );
    yield put(UserManageDetailActions.setCheckApplication(response));
    yield put(UserManageDetailActions.setIsCheck((prev: any) => !prev));
    if (response == false) {

      yield put(UserManageDetailActions.setIsApplicationCheck(false));
    } else {
      yield put(UserManageDetailActions.setIsApplicationCheck(true));
      yield put(UserManageDetailActions.SetAddApplication(0))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setIsApplicationCheck(true));
    yield put(UserManageDetailActions.setCheckApplication(true));
    yield put(UserManageDetailActions.SetAddApplication(0))
    yield put(globalLoaderText(""));
  }
}

function* createApplication(req: any): any {
  yield put(globalLoaderText("loading...."));
  let response: any = 0;
  try {
    let val = req.order
    let payloadData : IPayload = {
      apiMethod: apiMethod.POST,
      apiType: apiType.Identity,
      endpoint: `applications`,
      payload: val
    }
    if (req.order.id == 0) {
      yield put(globalLoaderText("Creating Application...."));
      response = yield call(
        api.callUserPost, API_URL.PostWebApp, payloadData
      );
    } else {
      
      let payloadData : IPayload = {
        apiMethod: apiMethod.PUT,
        apiType: apiType.Identity,
        endpoint: `applications`,
        payload: val
      }
      yield put(globalLoaderText("Updating Application...."));
      response = yield call(
        api.callUserPost, API_URL.PostWebApp, payloadData
      );
    }
    if (response) {
      yield put(UserManageDetailActions.SetAddApplication(response))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.SetAddApplication("error"))
    yield put(globalLoaderText(""));
  }
}

function* deleteCategory(req: any): any {
  yield put(globalLoaderText("Deleting Category...."));
  let categoryId = req.val
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.PUT,
      apiType: apiType.Identity,
      endpoint: `applications/categories/${categoryId}`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setDeleteCategory(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setDeleteCategory(false));
    yield put(globalLoaderText(""));
  }
}
function* getCategoryById(req: any): any {
  yield put(globalLoaderText("fetching Category Data...."));
  let categoryId = req.val
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/categories/${categoryId}`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setCategoryById(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setCategoryById([]));
  }
}
function* deleteAppArea(req: any): any {
  yield put(globalLoaderText("Deleting App Area...."));
  let appAreaId = req.val
  let payloadData : IPayload = {
    apiMethod: apiMethod.PUT,
    apiType: apiType.Identity,
    endpoint: `applications/appareas/${appAreaId}`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setDeleteAppArea(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setDeleteAppArea(false));
    yield put(globalLoaderText(""));
  }
}

function* getApplicationById(req: any): any {
  yield put(globalLoaderText("fetching Application Data...."));
  let applicationId = req.val
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `applications/${applicationId}`,
      payload : null
    }
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setApplicationById(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setApplicationById([]));
  }
}

function* deleteApplication(req: any): any {
  yield put(globalLoaderText("Deleting Application...."));
  let applicationId = req.val
  try {
    let payloadData : IPayload = {
      apiMethod: apiMethod.PUT,
      apiType: apiType.Identity,
      endpoint: `applications/${applicationId}`,
      payload : null
    }
    const responses = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.setDeleteApplication(responses));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setDeleteApplication(false));
    yield put(globalLoaderText(""));
  }
}

function* getSecurityPermissionData(val: any): any {
  yield put(globalLoaderText("fetching Datas...."));
  let payloadData : IPayload ={
    apiMethod: apiMethod.GET,
    apiType: apiType.Identity,
    endpoint: `users/${val?.val}/userrolepermissions`,
    payload : null
  }
  try {
    const response = yield call(api.callUserPost,API_URL.PostWebApp,payloadData );
    yield put(UserManageDetailActions.setSecurityPermissionList(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setSecurityPermissionList([]));
  }
}

function* getSecurityRoleData(val: any): any {
  if (val.hasOwnProperty("val")) {
    yield put(globalLoaderText("fetching Datas...."));
    try {
      let payloadData : IPayload = {
        apiMethod: apiMethod.GET,
        apiType: apiType.Identity,
        endpoint: `users/${val?.val}/userroles`,
        payload : null
      }
      const response = yield call(api.callUserPost,API_URL.PostWebApp,payloadData );
      yield put(UserManageDetailActions.setSecurityRoleList(response));
      yield put(globalLoaderText(""));
    } catch (error) {
      yield put(globalLoaderText(""));
      yield put(UserManageDetailActions.setSecurityRoleList([]));
    }
  }
}

function* getUserGridData(req: any): any {
  
let payloadData : IPayload = {
  apiMethod: apiMethod.POST,
  apiType: apiType.Identity,
  endpoint: 'users/grid',
  payload : req?.payload
}
  yield put(globalLoaderText("fetching Users...."));
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData);
    if (response) {
      yield put(UserManageDetailActions.setUserGridData(response));
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setUserGridData({}));
    yield put(globalLoaderText(""));
  }
}

function* getUserByUPN(req: any): any {
  const email = req.payload;
  
  let payloadData : IPayload = {
  apiMethod: apiMethod.GET,
  apiType: apiType.Identity,
  endpoint: `users/account/${email}`,
  payload : null
  }
  yield put(globalLoaderText("fetching User UPN...."));
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData );
    yield put(UserManageDetailActions.setUserByUPN(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setUserByUPN({accountEnabled:false}));
    yield put(globalLoaderText(""));
  }
}

function* getUserDivisions (): any {
  let payloadData : IPayload = {
    apiType : apiType.Organization,
    endpoint : `organizations/dropdown/divisions`,
    apiMethod : apiMethod.GET,
    payload : null
  }
    
  yield put(globalLoaderText("fetching divisions...."));
  try {
    const response = yield call(api.callOrganizationPost, API_URL.PostWebApp,payloadData );
    const defaultOption = {
      text: "Select Default Company",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(UserManageDetailActions.setUserDivisions(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
  }
}

function* getUserCostCenter (req: any): any {
  const regionId = req.payload;
  
  let payloadData : IPayload = {
  apiMethod: apiMethod.GET,
  apiType: apiType.Organization,
  endpoint: `organizations/dropdown/costcenter/${regionId}`,
  payload : null
  }
  yield put(globalLoaderText("fetching cost center...."));
  try {
    const response = yield call(api.callOrganizationPost,API_URL.PostWebApp,payloadData );
    const defaultOption = {
      text: "Select Cost Center",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(UserManageDetailActions.setUserCostCenter(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
  }
}

function* createUser(req: any): any {
  const userData = req.payload;
  let payloadData : IPayload = {
    apiMethod: apiMethod.POST,
    apiType: apiType.Identity,
    endpoint: 'users',
    payload : userData
  }
  yield put(globalLoaderText("Creating User...."));
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData);
    yield put(UserManageDetailActions.SetCreateUser(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.SetCreateUser("error"));
    yield put(globalLoaderText(""));
  }
}

function* getUserById(req: any): any {
  const userId = req.payload;
  
  let payloadData : IPayload = {
  apiMethod: apiMethod.GET,
  apiType: apiType.Identity,
  endpoint: `users/${userId}`,
  payload : null
  }
  yield put(globalLoaderText("fetching User...."));
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp,payloadData );
    yield put(UserManageDetailActions.setUser(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setUser({}));
    yield put(globalLoaderText(""));
  }
}

function* getActiveRolesData(val: any): any {
  let payloadData : IPayload = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Identity,
    endpoint: `users/${val?.val}/userroles/active`,
    payload : null
  }
  yield put(globalLoaderText("fetching Datas...."));
  try {
    const response = yield call(api.callUserPost,API_URL.PostWebApp,payloadData );
    yield put(UserManageDetailActions.SetActiveRoles(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.SetActiveRoles([]));
  }
}

function* createSecurityRole(req: any): any {
  yield put(globalLoaderText("loading...."));
  let response: any = 0;
  try {
    let val = req.order
    let payloadData : IPayload = {
      apiMethod: apiMethod.POST,
      apiType: apiType.Identity,
      endpoint: `users/userroles`,
      payload: val
    }
    if (req?.order?.hasOwnProperty("userId")) {
      yield put(globalLoaderText("Assigning Security Roles...."));
      response = yield call(
        api.callUserPost,API_URL.PostWebApp
        , payloadData
      );
    } else {
      let payloadData : IPayload = {
        apiMethod: apiMethod.PUT,
        apiType: apiType.Identity,
        endpoint: `users/userroles`,
        payload: val
      }
      yield put(globalLoaderText("Updating Security Role...."));
      response = yield call(
        api.callUserPost,
        API_URL.PostWebApp, payloadData
      );
    }
    if (response) {
      yield put(UserManageDetailActions.SetAddSecurityRole(response))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.SetAddSecurityRole("error"))
    yield put(globalLoaderText(""));
  }
}

function* updateUser(req: any): any {
  const userData = req.payload;
  let payloadData : IPayload = {
    apiMethod: apiMethod.PUT,
    apiType: apiType.Identity,
    endpoint: 'users',
    payload : userData
  }
  yield put(globalLoaderText("updating User...."));
  try {
    const response = yield call(api.callUserPost, API_URL.PostWebApp, payloadData );
    yield put(UserManageDetailActions.SetCreateUser(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.SetCreateUser("error"));
    yield put(globalLoaderText(""));
  }
}

function* checkUserDuplication(req: any): any {
  yield put(globalLoaderText("Checking Duplication...."));
  try {
    let userId = req.val.userId;
    let userName = req.val.adUserId;
    let email = req.val.email;
    let employeeId = req.val.employeeId;
    let payloadData : IPayload = {
      apiMethod: apiMethod.GET,
      apiType: apiType.Identity,
      endpoint: `users/check?userId=${userId}&userName=${userName}&email=${email}&employeeId=${employeeId}`,
      payload : null
    }
    const response = yield call(
      api.callUserPost, API_URL.PostWebApp, payloadData      
    );
    yield put(UserManageDetailActions.setCheckUser(response));
    yield put(UserManageDetailActions.setIsCheck((prev: any) => !prev));
    if (!response) {

      yield put(UserManageDetailActions.setIsUserCheck(false));
    } else {
      yield put(UserManageDetailActions.setIsUserCheck(true));
      yield put(UserManageDetailActions.SetCreateUser(0))
    }
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(UserManageDetailActions.setIsUserCheck(true));
    yield put(UserManageDetailActions.setCheckUser(true));
    yield put(UserManageDetailActions.SetCreateUser(0))
    yield put(globalLoaderText(""));
  }
}

function* getTimeZoneData(): any {
  let payloadData : IPayload = {
    apiMethod: apiMethod.GET,
    apiType: apiType.Organization,
    endpoint: `organizations/dropdown/timezones`,
    payload : null
    }
  yield put(globalLoaderText("fetching Datas...."));
  try {
    const response = yield call(api.callOrganizationPost, API_URL.PostWebApp,payloadData);
    const defaultOption = {
      text: "Select Time Zone",
      value: null,
    };
    response.unshift(defaultOption);
    yield put(UserManageDetailActions.SetTimeZone(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.SetTimeZone([]));
  }
}
function* uploadAppicationIcon(req: any): any {
  yield put(globalLoaderText("Uploading Icon...."));
  try {
    let formObject = req.payload
    formObject.append('apiMethod', apiMethod.POST)
    formObject.append('apiType', apiType.Identity)
    formObject.append('endpoint', `applications/upload/icon`)
    const response = yield call(api.callUserPost, `${API_URL.PostWebApp}/upload/attachments`, formObject);
    yield put(UserManageDetailActions.setApplicationIcon(response));
    yield put(globalLoaderText(""));
  } catch (error) {
    yield put(globalLoaderText(""));
    yield put(UserManageDetailActions.setApplicationIcon(""));
  }
}

function* watcherGetMyOrder() {
  yield takeEvery(GET_CATEGORY_LISTING, getCategoryListingData);
  yield takeEvery(GET_CHECK_APP_PERMISSION, checkAppPerDuplication)
  yield takeEvery(GET_ADD_APP_PERMISSION, createApplicationPermission)
  yield takeEvery(GET_APPLICATION_LISTING, getApplicationListingData)
  yield takeEvery(GET_APP_AREA_LISTING, getAppAreaListingData)
  yield takeEvery(GET_ACTIVE_CATEGORY, getActiveCategoryData)
  yield takeEvery(GET_CHECK_CATEGORY, checkCategoryDuplication)
  yield takeEvery(GET_ADD_CATEGORY, createCategory)
  yield takeEvery(GET_APP_PERMISSION_LISTING, getAppPermissionListData)
  yield takeEvery(GET_APP_PERMISSION_BY_ID, getAppPermissionById)
  yield takeEvery(GET_DELETE_APP_PERMISSION, deleteAppPermission)
  yield takeEvery(GET_DELETE_SECURITY_ROLE, deleteSecurityRole)
  yield takeEvery(GET_APP_AREA_CHECK, checkAppAreaDuplication)
  yield takeEvery(GET_ADD_APP_AREA, createCategory)
  yield takeEvery(GET_APP_AREA_BY_ID, getAppAreaById)
  yield takeEvery(GET_APPLICATION_CHECK, checkApplicationDuplication)
  yield takeEvery(GET_ADD_APPLICATION, createApplication)
  yield takeEvery(GET_DELETE_CATEGORY, deleteCategory)
  yield takeEvery(GET_CATEGORY_BY_ID, getCategoryById)
  yield takeEvery(GET_DELETE_APP_AREA, deleteAppArea)
  yield takeEvery(GET_ACTIVE_APPLICATION, getActiveApplicationData)
  yield takeEvery(GET_ACTIVE_APP_AREA, getActiveAppAreaData)
  yield takeEvery(GET_APPLICATION_BY_ID, getApplicationById)
  yield takeEvery(GET_DELETE_APPLICATION, deleteApplication)
  yield takeEvery(GET_CREATE_USER, createUser)
  yield takeEvery(GET_USER_GRID_DATA, getUserGridData)
  yield takeEvery(GET_USER, getUserById);
  yield takeEvery(GET_SECURITY_PERMISSION_LISTING, getSecurityPermissionData)
  yield takeEvery(GET_SECURITY_ROLE_LISTING, getSecurityRoleData)
  yield takeEvery(GET_ACTIVE_ROLES, getActiveRolesData)
  yield takeEvery(GET_ADD_SECURITY_ROLE, createSecurityRole)
  yield takeEvery(GET_SECURITY_ROLE_BY_ID, getSecurityRoleById);
  yield takeEvery(UPDATE_CREATE_USER, updateUser);
  yield takeEvery(GET_USER_UPN_DATA, getUserByUPN);
  yield takeEvery(GET_USER_DIVISIONS, getUserDivisions);
  yield takeEvery(GET_USER_COST_CENTER, getUserCostCenter);
  yield takeEvery(GET_CHECK_USER, checkUserDuplication);
  yield takeEvery(GET_TIME_ZONE,getTimeZoneData);
  yield takeEvery(UPLOAD_APPLICATION_ICON, uploadAppicationIcon);
}

export default function* combinedSaga() {
  yield all([
    watcherGetMyOrder()
  ])
}